import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const customerApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
      method: "patch",
      data,
    }),
  findDebts: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}/debts`,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/customer/${id}`,
      method: "delete",
    }),
  importExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/customer/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },
};
